/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LocationOption/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function LocationOption({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentAutomations/AutomationsList/CopyAction/Content/Content/LocationOption"
  
}) {
let tabSelectedCopyToLocationsValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.copy_to_locations',
})
let locationIdValueData = fromData.useDataValue({ viewPath,
context: 'location',
path: '_id',
})
let aggregateData = fromAggregate.includes(tabSelectedCopyToLocationsValueData, locationIdValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
let locationNameValueData = fromData.useDataValue({ viewPath,
context: 'location',
path: 'name',
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 marginTop={dtSpaceXs}
 data="tab.selected.copy_to_locations"
 data="location._id"
 aggregate="/Data/aggregate.js includes"
 value={aggregateData}
 onChange={onChange}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 textOverflow="ellipsis"
 whiteSpace="nowrap"
 overflowX="hidden"
 data="location.name"
 text={locationNameValueData}
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}